import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useStoreServiceApi } from "@/api/hooks/storeService.hook";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";

import ProfilePreferences from "./preferences.component";

const ProfilePreferencesContainer = () => {
    const customer = useSelector(getCustomer);
    const [{ data }, loadStore] = useStoreServiceApi<any, any, CloudStore>(
        {
            url: `/localized/stores/`
        },
        { manual: true }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (customer?.favouriteStoreId) {
            loadStore({
                url: `/localized/stores/${customer.favouriteStoreId}`
            });
        }
    }, [customer?.favouriteStoreId]);

    return (
        <>
            {customer && (
                <ProfilePreferences
                    customer={customer}
                    storeDetails={data}
                />
            )}
        </>
    );
};

export { ProfilePreferencesContainer };
